import { render, staticRenderFns } from "./DashboardSliderCards.vue?vue&type=template&id=6460f2a1&scoped=true"
import script from "./DashboardSliderCards.vue?vue&type=script&lang=js"
export * from "./DashboardSliderCards.vue?vue&type=script&lang=js"
import style0 from "./DashboardSliderCards.vue?vue&type=style&index=0&id=6460f2a1&prod&lang=sass&scoped=true"
import style1 from "./DashboardSliderCards.vue?vue&type=style&index=1&id=6460f2a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6460f2a1",
  null
  
)

export default component.exports